<template>
  <div id="indexComponent" class="leagues-page">
    <Header
      @onChangLogin="onChangLogin"
      :isLogin="loginShow"
      @onChangeSetting="onChangeSetting"
    />
    <NavBar :tab="2" @onChangLogin="onChangLogin" :isLogin="loginShow" />
    <div class="page-content flex flex-pack-justify">
      <div class="page-left">
        <AllLeagues :list="leagueList" @leagueChange="onLeagueChange" />
      </div>
      <div class="page-center">

      </div>
      <div class="page-right">
        <template v-if="ListAd.length > 0">
          <template v-for="(item, index) in ListAd">
            <div class="ad-box" v-if="item.siteId == 301" :key="index">
              <router-link
                :to="'/gdt?gdtUrl=' + item.url"
                target="_blank"
                @click.native="adHit(item.id)"
                ><img :src="item.img"
              /></router-link>
            </div>
          </template>
          <template v-for="(item, index) in ListAd">
            <div class="ad-box ad-sticky" v-if="item.siteId == 302" :key="index">
              <router-link
                :to="'/gdt?gdtUrl=' + item.url"
                target="_blank"
                @click.native="adHit(item.id)"
                ><img :src="item.img"
              /></router-link>
            </div>
          </template>
        </template>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import { getListAd, getLeagueDefaultHot, getLeagueList } from "@/api/api";
import Header from "@/components/header.vue";
import NavBar from "@/components/navbar.vue";
import Footer from "@/components/footer.vue";
import AllLeagues from "./components/allLeagues";
export default {
  name: "team",
  components: {
    Header,
    NavBar,
    Footer,
    AllLeagues
  },
  data() {
    return {
      setting: {},
      loginShow: false,
      ListAd: [], //  广告列表
      leagueList: [],
    }
  },
  methods: {
    onChangeSetting(res) {
      this.setting = res;
    },
    onChangLogin(_val) {
      if (_val.loginShow || _val) {
        this.loginShow = true;
      } else {
        this.loginShow = false;
      }
    },
    // 广告
    async loadAdList() {
      const response = await getListAd({
        //广告
        pageId: 3,
      });
      if (response.state == 200) {
        const _data = this.common.jsonParse(response.data || null);
        // console.log("广告", _data);
        this.ListAd = _data.webAds || [];
      }
    },

    async loadLeagueList() {
      let leagueId = this.$route.params.id * 1 || "";

      await getLeagueDefaultHot({
        userToken: '',
      }).then((res) => {
        let data=JSON.parse(JSON.stringify(res.data));
        if(leagueId == ''){
          leagueId = data.id;
        }
      }).catch((res) => {
        console.error(res)
      })

      const response = await getLeagueList({
        leagueId,
        userToken: "",
      });
      if (response.state === 200) {
        const _data = response.data;
        const group = _data["group"] || [];
        let _list = [];
        group.forEach((continent) => {
          continent.country.forEach((country) => {
            if (country.id) _list.push(country);
          });
        });
        this.leagueList = _list;
      }
    },

    onLeagueChange(country, league) {
      this.$router.push(
        // `/leagues/${league.id}/${this.$route.params?.tab ?? 0}`
        `/leagues/${league.id}/0`
      );
    },
  },
  mounted() {
    this.loadAdList();
    this.loadLeagueList()
  }
}
</script>
<style lang="less" scoped>
.page-content{
    max-width:1200px;
    margin:0 auto;
    padding:8px 16px 0;
}
.page-left{
    width:168px;
    padding-right:8px;
}
.page-center{
    flex:1;
    max-width:auto;
    min-width:535px;
}
.page-right{
    width:208px;
    padding-left:8px;
}
</style>


// WEBPACK FOOTER //
// ./src/views/team/index.vue